export const annualPlan = {
  // Page
  annualPlanTitle: 'Annual Plan',
  annualPlanSubtitle: 'Plan your year with AI assistance',
  annualPlanDescription: 'Create your annual plan guided by artificial intelligence',
  planYourYear: 'Plan your year with clear goals',

  // Steps
  stepWelcome: 'Welcome',
  stepReflection: 'Reflection',
  stepLifeAreas: 'Life Areas',
  stepGoals: 'Goals',
  stepReview: 'Review',
  stepSummary: 'Summary',

  // Welcome
  welcomeBadge: '{year} Plan',
  welcomeTitle: 'Design Your Best Year',
  welcomeDescription: "I'll guide you step by step to create a meaningful and achievable annual plan. Together we'll reflect on the ending year and build clear goals for the next one.",
  welcomeFeature1Title: 'Guided Reflection',
  welcomeFeature1Desc: 'Analyze your achievements and learnings',
  welcomeFeature2Title: 'SMART Goals',
  welcomeFeature2Desc: 'AI helps you create specific and measurable goals',
  welcomeFeature3Title: 'Reminders',
  welcomeFeature3Desc: 'Set up automatic quarterly reviews',
  welcomeFeature4Title: 'AI Suggestions',
  welcomeFeature4Desc: 'Get personalized ideas based on your reflection',
  startPlanning: 'Start Planning',
  welcomeTimeEstimate: 'Approximately 15-30 minutes',

  // Reflection
  reflectionIntro: "Hello! Before planning the next year, let's take a moment to reflect on the year that's ending. This will help us create a more meaningful plan aligned with your experiences.",
  reflection_achievements: 'What were your biggest achievements?',
  reflection_achievements_placeholder: 'Completed projects, achieved goals, proud moments...',
  reflection_challenges: 'What challenges did you face?',
  reflection_challenges_placeholder: 'Obstacles overcome, difficulties that made you grow...',
  reflection_learnings: 'What did you learn this year?',
  reflection_learnings_placeholder: 'Life lessons, new skills, personal insights...',
  reflection_gratitude: 'What are you grateful for?',
  reflection_gratitude_placeholder: 'People, experiences, opportunities you appreciate...',
  getAIInsights: 'Get AI Insights',

  // Life Areas
  lifeAreasIntro: "Great reflection! Now let's identify the areas of your life you want to focus on next year. Select those that are priorities for you.",
  selectLifeAreas: 'Suggested Life Areas',
  addCustomArea: 'Add custom area...',
  selectedAreas: 'Selected Areas',
  aiSuggestedAreas: 'Based on your reflection, I suggest focusing on:',
  getAreaSuggestions: 'Get area suggestions',
  
  // Area names
  area_health: 'Health',
  area_career: 'Career',
  area_finances: 'Finances',
  area_relationships: 'Relationships',
  area_personal_growth: 'Personal Growth',
  area_hobbies: 'Hobbies',
  area_spirituality: 'Spirituality',
  area_home: 'Home',
  area_legal: 'Legal',

  // Goals
  goalsIntro: "Now let's define specific goals for each area you selected. I'll help with suggestions based on your reflection.",
  goalsCreated: 'goals created',
  areasWithGoals: 'areas with goals',
  yourGoals: 'Your Goals',
  aiSuggestedGoals: 'AI suggestions for this area:',
  addNewGoal: 'Add New Goal',
  goalTitle: 'Goal Title',
  goalTitlePlaceholder: 'E.g.: Run a marathon',
  goalDescription: 'Description (optional)',
  goalDescriptionPlaceholder: 'Additional details about the goal...',
  targetQuarter: 'Target Quarter',
  addGoal: 'Add Goal',
  suggestGoalsForArea: 'Suggest goals for this area',
  goals: 'goals',

  // Review
  reviewIntro: "Excellent work! You've created {count} goals for next year. Review your plan before saving.",
  noGoalsYet: 'No goals yet',
  edit: 'Edit',
  createQuarterlyReminders: 'Create quarterly reminders',
  quarterlyRemindersDescription: "You'll receive a reminder at the start of each quarter to review your progress.",
  quarterlyReview: 'Quarterly Review',
  quarterlyReviewDescription: "It's time to review your progress on your annual plan goals.",
  saveAndFinish: 'Save and Finish',
  saving: 'Saving...',
  planSaved: 'Plan Saved',
  planSavedDescription: '{count} goals were created successfully.',
  errorSavingPlan: 'Error saving the plan',

  // Summary
  congratulations: 'Congratulations!',
  planComplete: 'Your plan for {year} is ready',
  summaryMessage: "You've created a complete plan with {count} goals across {areas} life areas. Your goals are saved and reminders are set. Best of luck in the coming year!",
  lifeAreas: 'life areas',
  remindersSet: 'reminders',
  planYear: 'plan year',
  exportPlan: 'Export Plan',
  exportSuccess: 'Export successful',
  pdfDownloaded: 'The PDF has been downloaded',
  docxDownloaded: 'The Word document has been downloaded',
  exportError: 'Export error',
  print: 'Print',
  nextSteps: 'Next Steps',
  viewGoals: 'View my Goals',
  viewReminders: 'View Reminders',
  startNewPlan: 'Create New Plan',
  goToDashboard: 'Go to Dashboard',

  // Common
  back: 'Back',
  continue: 'Continue',
  error: 'Error',

  // Auto-save
  autoSaving: 'Saving...',
  savedAt: 'Saved',
  saveError: 'Save error',
  autoSaveEnabled: 'Auto-save enabled',
  justNow: 'just now',
  minutesAgo: 'min ago',
  hoursAgo: 'h ago',
  draftFound: 'Draft found',
  draftFoundMessage: 'A saved draft was found. Would you like to continue where you left off?',
  continueDraft: 'Continue draft',
  startFresh: 'Start fresh',

  // Area Reflection Questions
  areaReflectionTitle: 'Reflection on this area',
  areaReflectionDescription: 'Before setting your goals, briefly reflect on this area of your life:',
  areaReflection_keep: 'What to keep?',
  areaReflection_keep_placeholder: 'Habits or practices that work well...',
  areaReflection_reduce: 'What to reduce?',
  areaReflection_reduce_placeholder: 'Excesses you want to moderate...',
  areaReflection_increase: 'What to increase?',
  areaReflection_increase_placeholder: 'Positive things you want to enhance...',
  areaReflection_eliminate: 'What to eliminate?',
  areaReflection_eliminate_placeholder: 'Things that don\'t add value...',
  areaReflection_implement: 'What to implement?',
  areaReflection_implement_placeholder: 'New initiatives to start...',
};
